import { render } from "./Footer.vue?vue&type=template&id=73cceed8&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=73cceed8&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73cceed8"]])

export default __exports__